export const SITE = {
  brand: "Metamorphosis Institute of Transformation LLP",
  short: "MIT LLP",
  since: 2012,
  tagline: "Let's spell greater S_CCESS with a new 'U'",
  positioning: "Your preferred Transformational Partners",
  emails: {
    info: "info@mitllp.com",
    placements: "m.placements@mitllp.com",
  },
  phones: {
    service: "+91 97129 93771",
    placements: "+91 84602 05913",
    service_name: "Mr. Aankit",
  },
  website: "www.mitllp.com",
  social: {
    linkedin: "https://www.linkedin.com/company/metamorphosis-institute-of-transformation",
    facebook: "https://www.facebook.com/mitllpglobal",
    instagram: "https://www.instagram.com/mitllp",
    youtube: "https://www.youtube.com/@mitllp",
  },
};

export const STATS = [
  { label: "Assignments", value: 1000, suffix: "+" },
  { label: "Lives Impacted", value: 900000, suffix: "+" },
  { label: "Industries Served", value: 60, suffix: "+" },
  { label: "Client Retention", value: 98, suffix: "%" },
];

export const CORE_VALUES = ["Accountability", "Learning", "Integrity", "Collaboration", "Excellence"];

export const SERVICES = [
  {
    id: "trainings",
    number: "01",
    title: "Transformational Trainings",
    tagline: "In-house & Bespoke",
    image: "https://images.pexels.com/photos/36701627/pexels-photo-36701627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    excerpt: "From 7 Habits to Leadership Development — 30+ programs designed for people, not slide decks.",
    items: [
      "7 Habits of Highly Effective People / Manager / Leader",
      "Leadership Development · Self-Managed Leadership",
      "Advance Selling Skills · Basic Sales Cycle",
      "Communication Skills — Basics & Advance",
      "Emotional Intelligence · Stress Management",
      "Behavioural Interview Skills · Facilitation",
      "Team Building · Team Bonding · Goal Setting",
      "Time Management · Conflict Resolution",
    ],
  },
  {
    id: "outbound",
    number: "02",
    title: "Outbound Learning Experiences",
    tagline: "MIT's Unique Creations",
    image: "https://images.pexels.com/photos/36701627/pexels-photo-36701627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940&fit=crop&crop=entropy",
    excerpt: "The 5th Gear, RISE, and \"We don't need your best\" — signature outdoor programs that rewire teams.",
    items: [
      "The 5th Gear — for Sales Teams across levels",
      "The 5th Gear — for Leadership Teams",
      "RISE — Motivation, Goal Setting, Target Orientation",
      "We don't need your best — Team building & bonding",
    ],
  },
  {
    id: "consultancies",
    number: "03",
    title: "Business Consultancies",
    tagline: "Bridge the AS-IS to TO-BE",
    image: "https://images.pexels.com/photos/36701627/pexels-photo-36701627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940&fit=crop&crop=top",
    excerpt: "Process, productivity, growth, sales & marketing consulting — result-first, jargon-last.",
    items: [
      "Process Consultancy",
      "Productivity Enhancement",
      "Organizational Growth Consultancy",
      "Sales Consultancy",
      "Marketing Consultancy",
    ],
  },
  {
    id: "coaching",
    number: "04",
    title: "Mentorship & Coaching",
    tagline: "One conversation, transformed",
    image: "https://images.pexels.com/photos/36701627/pexels-photo-36701627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940&fit=crop&crop=center",
    excerpt: "1:1 mentoring for founders, executives and life stages — plus group cohorts.",
    items: [
      "1-2-1 Mentoring · Group Mentoring",
      "Start-Up Mentoring",
      "Mentorship Training",
      "Life · Executive · Leadership · Relationship Coaching",
    ],
  },
  {
    id: "hr",
    number: "05",
    title: "Specialized HR Outsourcing",
    tagline: "Diagnose. Redesign. Deliver.",
    image: "https://images.pexels.com/photos/36701627/pexels-photo-36701627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940&fit=crop&crop=faces",
    excerpt: "Climatic surveys, satisfaction diagnostics, restructuring & escalation matrices.",
    items: [
      "Organizational Climatic Survey",
      "Employee Satisfaction Survey",
      "Organizational Restructuring",
      "Establishing Escalation Matrix",
    ],
  },
  {
    id: "metauni",
    number: "06",
    title: "MetaUni — Institutional Engagements",
    tagline: "Campus to Career",
    image: "https://images.pexels.com/photos/36701627/pexels-photo-36701627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940&fit=crop&crop=edges",
    excerpt: "Employability trainings, faculty development, parent-teacher-student engagements.",
    items: [
      "Students Employability Trainings",
      "Faculty Development Programs",
      "Non-Teaching Staff Trainings",
      "Parent + Teacher + Student engagements",
    ],
  },
];

export const CLIENTS = {
  Corporates: [
    { name: "IFFCO", domain: "iffco.in" },
    { name: "Reliance", domain: "ril.com" },
    { name: "Bridgestone", domain: "bridgestone.com" },
    { name: "HORIBA", domain: "horiba.com" },
    { name: "Lanxess", domain: "lanxess.com" },
    { name: "Adani Realty", domain: "adanirealty.com" },
    { name: "Bajaj", domain: "bajajauto.com" },
    { name: "Toyota Tsusho", domain: "toyota-tsusho.com" },
    { name: "TATA Motors", domain: "tatamotors.com" },
    { name: "Maruti Suzuki", domain: "marutisuzuki.com" },
    { name: "Hero MotoCorp", domain: "heromotocorp.com" },
    { name: "UltraTech Cement", domain: "ultratechcement.com" },
    { name: "Saint-Gobain", domain: "saint-gobain.com" },
    { name: "TCS", domain: "tcs.com" },
    { name: "Torrent Power", domain: "torrentpower.com" },
    { name: "NHPC", domain: "nhpcindia.com" },
    { name: "Rotary International", domain: "rotary.org" },
    { name: "Indian Red Cross", domain: "indianredcross.org" },
    { name: "LG Life Sciences", domain: "lg.com" },
  ],
  Pharmaceutical: [
    { name: "Zydus", domain: "zyduslife.com" },
    { name: "Intas", domain: "intaspharma.com" },
    { name: "Cadila Pharma", domain: "cadilapharma.com" },
    { name: "Cipla", domain: "cipla.com" },
    { name: "Otsuka", domain: "otsuka.co.jp" },
    { name: "HOF Pharma", domain: "hofpharma.com" },
    { name: "Vidakem", domain: "vidakem.com" },
  ],
  "FMCG & Hospitality": [
    { name: "Amul", domain: "amul.com" },
    { name: "Parle", domain: "parleproducts.com" },
    { name: "Britannia", domain: "britannia.co.in" },
    { name: "Tulsi Tea", domain: "tulsitea.com" },
    { name: "Hearty Mart", domain: "heartymart.com" },
    { name: "Hathi Masala", domain: "hathimasala.com" },
    { name: "Club O7", domain: "clubo7.com" },
    { name: "Upper Crust", domain: "uppercrust.co.in" },
    { name: "Farki", domain: "farki.in" },
  ],
  "Banking & Finance": [
    { name: "ICICI Bank", domain: "icicibank.com" },
    { name: "HDFC Bank", domain: "hdfcbank.com" },
    { name: "Bank of Baroda", domain: "bankofbaroda.in" },
    { name: "Kalupur Bank", domain: "kalupurbank.com" },
    { name: "Mahindra Home Finance", domain: "mahindrahomefinance.com" },
    { name: "Mahindra Finance", domain: "mahindrafinance.com" },
    { name: "L&T Financial", domain: "ltfs.com" },
    { name: "NIBF", domain: "nibfindia.com" },
    { name: "Calyx", domain: "calyx.com" },
  ],
  Institutions: [
    { name: "Nirma University", domain: "nirmauni.ac.in" },
    { name: "PDEU", domain: "pdpu.ac.in" },
    { name: "GLS University", domain: "glsuniversity.ac.in" },
    { name: "Indrashil University", domain: "indrashiluniversity.edu.in" },
    { name: "Karnavati University", domain: "karnavatiuniversity.edu.in" },
    { name: "RCC IIT", domain: "rcciit.org.in" },
    { name: "GIER", domain: "gier.edu.in" },
    { name: "i-Hub Gujarat", domain: "ihub-gujarat.in" },
  ],
};

export const TESTIMONIALS = [
  {
    quote: "Our sales team didn't just close more — they thought differently. The 5th Gear stayed with them for months.",
    author: "Rakesh Menon",
    role: "VP Sales, Manufacturing",
  },
  {
    quote: "The breakthrough innovators — that's what we call them. Two workshops in and our leadership language completely shifted.",
    author: "Priya Shah",
    role: "CHRO, Pharma",
  },
  {
    quote: "MIT's diagnostic work re-drew our org chart in ways we couldn't see from the inside. Retention is up 22%.",
    author: "Anand Iyer",
    role: "Managing Director, FMCG",
  },
  {
    quote: "The mentorship felt like being edited by someone who genuinely wanted my next chapter to be better than the last.",
    author: "Neha Kapoor",
    role: "Founder, D2C Startup",
  },
];

export const CHAPTERS = [
  {
    number: "01",
    kicker: "About",
    title: "Since 2012, we've made \"transformation\" a verb.",
    body: "Metamorphosis Institute of Transformation LLP is a PAN-India transformation partner for individuals, teams and organizations. We combine training, consulting, mentoring and outbound learning into a single, results-obsessed practice.",
  },
  {
    number: "02",
    kicker: "Vision",
    title: "To be the most resourceful institution for transformation of individuals and organizations.",
    body: "Every engagement is designed to make our clients less dependent on us over time. Real transformation is measurable, transferable, and unmistakable.",
  },
  {
    number: "03",
    kicker: "Mission",
    title: "To be the bridge between 'AS IS' and 'TO BE' for your business, via breakthrough innovations.",
    body: "Our methods borrow from behavioural science, business consulting and experiential learning — and refuse to borrow anything from templates.",
  },
];
